import { createPromise } from "common/promises";
import log from "loglevel";
import { assertNotNulls } from "./assert";
import { Types } from "./createjs";
import { logError } from "./error";
import { noop } from "./functions";
import { VideoLoader } from "./htmlVideoLoader";
export async function load({ onProgress, onComplete, onAudio, onVideo, onFileload, onFileProgress, filePaths, preferXHR = true, }) {
    const { promise, resolve, reject } = await createPromise();
    const result = {};
    const queue = new createjs.LoadQueue(preferXHR);
    queue.setMaxConnections(5);
    queue.on("progress", ({ progress }) => {
        if (onProgress) {
            onProgress(progress);
        }
    });
    queue.on("fileprogress", (arg) => {
        if (onFileProgress) {
            onFileProgress({
                id: arg.item.id,
                progress: arg.progress,
            });
        }
    });
    queue.on("complete", () => {
        if (onComplete) {
            onComplete();
        }
    });
    queue.on("complete", () => resolve(result));
    queue.on("fileload", (e) => {
        if (onFileload) {
            onFileload(e);
        }
        result[e.item.id] = {
            item: e.item,
            result: e.result,
            rawResult: e.rawResult,
        };
        onAudioVideoFileload(e, onAudio, onVideo);
    });
    queue.on("error", console.error);
    queue.on("error", reject);
    for (const file of filePaths) {
        log.trace("add load queue", file);
        log.trace("add load queue", JSON.stringify(file));
        queue.loadFile(file);
    }
    return promise;
}
function onAudioVideoFileload(event, onAudio, onVideo) {
    const item = event.item; // A reference to the item that was passed in to the LoadQueue
    const type = item.type;
    if (type == Types.VIDEO) {
        if (onVideo) {
            onVideo({ element: event.result, id: event.item.id });
        }
    }
    else if (type == Types.SOUND) {
        if (onAudio) {
            onAudio(event.result.src);
        }
    }
}
export var smartVideo;
(function (smartVideo) {
    /**
     * xhrAllProgress는 HTMLVideoElement로딩을 제외한 progress다.
     * 주의할 것.
     */
    async function load({ files, xhrAllProgress, }) {
        const xhrPromiseCallbacks = await createPromise();
        const xhrResults = {};
        const queue = new createjs.LoadQueue();
        queue.setMaxConnections(5);
        const htmlVideoLoadPromises = [];
        const xhrFileProgresses = {};
        queue.on("fileprogress", (arg) => {
            const id = arg.item.id;
            const progress = arg.progress;
            assertNotNulls(id, progress);
            // call callbacks
            if (xhrFileProgresses[id] != null) {
                xhrFileProgresses[id](progress);
            }
        });
        const xhrFileLoads = {};
        queue.on("fileload", (arg) => {
            const id = arg.item.id;
            const item = arg.item;
            const result = arg.result;
            // raw result can be null
            // the vtt file that contains trascription does not has rawResult
            const rawResult = arg.rawResult;
            assertNotNulls(id, item, result);
            if (xhrFileLoads[id] != null) {
                xhrFileLoads[id]({ item, result, rawResult });
            }
            else {
                log.debug("No file load event for ", id);
            }
            xhrResults[id] = { item, result, rawResult };
        });
        queue.on("error", logError);
        queue.on("error", xhrPromiseCallbacks.reject);
        queue.on("complete", xhrPromiseCallbacks.resolve);
        xhrAllProgress = xhrAllProgress || noop;
        queue.on("progress", ({ progress }) => xhrAllProgress(progress));
        const incID = new IncID();
        for (const file of files) {
            if (file.onProgress == null) {
                file.onProgress = noop;
            }
            switch (file.name) {
                case "normal":
                    const loadItem = extractSingleLoadItem(file.path, incID.issue());
                    xhrFileProgresses[loadItem.id] = file.onProgress;
                    xhrFileLoads[loadItem.id] = file.onComplete || noop;
                    if (file.type != null) {
                        loadItem.type = file.type;
                    }
                    queue.loadFile(loadItem);
                    break;
                case "video":
                    switch (file.method) {
                        case "xhr":
                            {
                                const loadItem = extractSingleLoadItem(file.path, incID.issue());
                                xhrFileProgresses[loadItem.id] = file.onProgress;
                                xhrFileLoads[loadItem.id] = file.onXHRFinished || noop;
                                queue.loadFile(loadItem);
                            }
                            break;
                        case "videoTag":
                            {
                                const loadItem = multipleLoadItem(file.path, () => incID.issue());
                                const videoEl = file.videoTagPrepare();
                                const videoLoader = new VideoLoader(videoEl, loadItem.map((item) => item.src), ({ loaded }) => {
                                    if (loaded != null) {
                                        file.onProgress(loaded);
                                    }
                                });
                                htmlVideoLoadPromises.push(videoLoader.load());
                            }
                            break;
                    }
                    break;
            }
        }
        await Promise.all([xhrPromiseCallbacks.promise, ...htmlVideoLoadPromises]);
        return xhrResults;
    }
    smartVideo.load = load;
})(smartVideo || (smartVideo = {}));
function extractSingleLoadItem(path, id) {
    let one;
    if (Array.isArray(path)) {
        one = path[0];
    }
    else {
        one = path;
    }
    if (typeof one === "string") {
        return {
            src: one,
            id: `Load-${id}`,
        };
    }
    else {
        if (one.id == null) {
            one.id = `Load-${id}`;
        }
        return one;
    }
}
function multipleLoadItem(path, id) {
    let multiple;
    if (Array.isArray(path)) {
        multiple = path;
    }
    else {
        multiple = [path];
    }
    return multiple.map((patha) => {
        if (typeof patha === "string") {
            return {
                src: patha,
                id: `Load-${id()}`,
            };
        }
        else {
            return Object.assign({ id: `Load-${id()}` }, patha);
        }
    });
}
class IncID {
    constructor() {
        this._id = 0;
    }
    issue() {
        const ret = this._id;
        this._id += 1;
        return ret;
    }
}
//# sourceMappingURL=loader.js.map